import { Box } from "@mui/material";
import {
	useEffect,
	type PropsWithChildren,
} from "react";

import { useResponsive } from "./useResponsive";

export const ResponsiveFrame = ({
	children,
}: PropsWithChildren) => {
	const responsive = useResponsive();

	useEffect(() => {
		document.documentElement.dataset.breakpoint =
			responsive.breakpoint;
		document.documentElement.dataset.pointer =
			responsive.pointer;

		return () => {
			delete document.documentElement.dataset.breakpoint;
			delete document.documentElement.dataset.pointer;
		};
	}, [responsive.breakpoint, responsive.pointer]);

	return (
		<Box
			className="responsive-frame"
			data-breakpoint={responsive.breakpoint}
			data-pointer={responsive.pointer}
			data-mobile={responsive.isMobile ? "true" : "false"}
			data-tablet={responsive.isTablet ? "true" : "false"}
		>
			{children}
		</Box>
	);
};
